import styled from '@emotion/styled'
import {
  Avatar as MuiAvatar,
  IconButton as MuiIconButton,
  TableCell as MuiTableCell,
  Tooltip as MuiTooltip,
  Typography,
} from '@material-ui/core'
import { Box } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'
import { ComponentType } from 'react'

type CustomProps = {
  titleLength?: number
  completed?: boolean
}

export const TaskTitleContainer = styled(Box)`
  display: flex;
  align-items: center;
  flex: 1;
`

export const ActionsContainer = styled(Box)`
  align-items: center;
  color: ${colors.interactive.primaryEnabled};
  cursor: pointer;
  display: flex;
`
export const TaskInfoContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  padding-left: 36px;
`
export const TaskTitleText = styled(Typography)<{ completed: string }>`
  ${typography.baseline.regularSans}
  text-decoration: ${({ completed }) =>
    completed === 'true' ? 'line-through' : 'none'};
  color: ${({ completed }) =>
    completed === 'true' ? colors.text.secondary : colors.text.primary};
  transition: color 0.3s ease, text-decoration 0.3s ease;
`
export const AddTeamMemberButton = styled(MuiIconButton)`
  color: ${colors.primary.main};
`
export const ActionsMenuButton = styled(MuiIconButton)`
  color: ${colors.primary.main};
`
export const AddOwner = styled(MuiIconButton)`
  color: ${colors.primary.main};
  cursor: pointer;
`
export const Avatar = styled(MuiAvatar)`
  width: 30px;
  height: 30px;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.common.white};
  background-color: ${colors.grey[600]};
`

export const Tooltip = styled(MuiTooltip)`
  .MuiTooltip-tooltip {
    font-size: 12px;
    padding: 8px 12px;
  }
`
export const AvatarAction = styled(Box)`
  cursor: pointer;
`

export const PopoverContent = styled(Box)`
  background: white;
  height: 143px;
  width: 565px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`
export const SelectContainer = styled(Box)`
  width: 100%;
`

export const OwnerContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`
export const SupplementalItem = styled(Box)`
  max-width: fit-content;
`
export const ExternalLink = styled.a`
  ${typography.baseline.semiBoldSans}
  color: ${colors.interactive.primaryEnabled};
  text-decoration: none;
`

export const TaskItemRowTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'completed',
})<CustomProps>`
  ${typography.baseline.semiBoldSans};
  color: ${colors.interactive.primaryEnabled};
  text-decoration: ${({ completed }) => (completed ? 'line-through' : 'none')};
`

export const TaskContentContainer = styled(MuiTableCell)`
  display: flex;
  flex-direction: column;
  border-bottom: none;
  padding: 16px;
  flex: 5;
`

export const DueDateContainer = styled(MuiTableCell)`
  border-bottom: none;
  padding: 16px;
  display: flex;
  align-items: center;
  flex: 2;
`

export const TaskActionsContainer = styled(MuiTableCell)`
  display: flex;
  align-items: center;
  border-bottom: none;
  padding: 16px;
  flex: 1;
`
export const MenuIcon = styled('div', {
  shouldForwardProp: (prop) => prop !== 'component',
})<{ component: ComponentType }>`
  margin-right: 8px;
  color: ${colors.interactive.disabledDark};
  display: flex;
  align-items: center;
`
